import React from 'react';
import ReactDOM from 'react-dom';
import Slides from '@ifeng-fe/ui_pc_slides';
import styles from './index.css';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng-fe/errorBoundary';
import { rel } from '@ifeng-fe/container_channel/common/client/utils/rel';
import Chip from 'Chip';

import RightTit from '../rightTit';

class SimpleSlider extends React.PureComponent {
    sliderTmpl = item => {
        return (
            <div className={styles.bigPic}>
                <a href={item.url} className={styles.pic_img} rel={rel}>
                    <img src={item.thumbnail} width="300" height="225" className={styles.trans} />
                </a>
                <div className={styles.text} />
                <p className={styles.title}>
                    <a href={item.url} rel={rel}>
                        {item.title}
                    </a>
                </p>
            </div>
        );
    };
    /**
     * 渲染组件
     */
    render() {
        const { content } = this.props;

        const config = {
            arrows: 'hover',
            dotStyle: styles.dot,
            dotCurrentStyle: styles.current,
            sliderTmpl: this.sliderTmpl,
        };

        return (
            <div className={styles.box}>
                <RightTit txt="凤凰商城" />
                <div className={styles.slideBox}>
                    <Chip
                        id="75201"
                        type="recommend"
                        title="轮播"
                        groupName="rightContent"
                        translate="handleStudioSlidePicData"
                        content={content}>
                        <Slides content={content} config={config} />
                    </Chip>
                </div>
            </div>
        );
    }
}

/**
 * 定义组件属性类型
 * */
SimpleSlider.propTypes = { content: PropTypes.array };

/**
 * 定义组件默认属性
 * */
SimpleSlider.defaultProps = {};

export default errorBoundary(SimpleSlider);
